export default __webpack_public_path__ + "static/quote_popup_image-f93e7e138363296780b1ff39ee51ba71.png";